import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-guests-for-listing',
  templateUrl: './dialog-guests-for-listing.component.html',
  styleUrls: ['./dialog-guests-for-listing.component.scss'],
})
export class DialogGuestsForListingComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  guests: [
    {
      name: string;
      picture: string;
      check_in_date: string; //formatted already
    },
  ];

  ngOnInit(): void {
    this.guests = this.data.guests;
  }
}
